@if (field.sequentialView && isLanding) {
  <div class="common-text-input__container-txchk-sequential">
    <div class="common-button__block-button-md-checkbox">
      <button class="common-button__icon-md-checkbox"
          [ngClass]="{'common-button__icon-md-checkbox--selected': fieldTypeTxchk.preSelectItem}"
          [disabled]="field.noEditable">
          <i class="common-icon__md"
            ngClass="{{fieldTypeTxchk.preSelectItem?'lf-icon-check-full':'lf-icon-box-inactive'}}"
            (click)="changeInField()"></i>
      </button>
    </div>
    <div>
      <div class="common-text-field__text-value-sequential"
        [innerHTML]="field.description"></div>
      @if (field.required) {
        <div class="common-tag__mandatory-obligatory-message">
          <span class="common-tag__mandatory-text-asterisk">*</span>
          <span class="common-tag__mandatory-label-text-obligatory"
            [ngClass]="{'common-tag__mandatory-label-text-obligatory--error': field.error}"
            [afTranslate]="'common.required-with-bracket'">(obligatorio)</span>
        </div>
      }
    </div>
  </div>
}@else {
  <div class="common-text-input__container"
    [id]="field.id">
    <div class="common-text-input__container-box-txchk"
      [ngClass]="{'common-text-input__container-box-txchk--error': field.error}"
      [attr.disabled]="field.noEditable?true:null">
      <div  class="common-button__block-typetext-checkbox">
        <div class="common-button__block-button-md-checkbox">
          <button class="common-button__icon-md-checkbox"
              [ngClass]="{'common-button__icon-md-checkbox--selected': fieldTypeTxchk.preSelectItem}"
              [disabled]="field.noEditable">
              <i class="common-icon__md"
                ngClass="{{fieldTypeTxchk.preSelectItem?'lf-icon-check-full':'lf-icon-box-inactive'}}"
                (click)="changeInField()"></i>
          </button>
        </div>
        <div class="common-button__block-text-checkbox">
          <span class="common-button__text-checkbox"
            [ngClass]="{'common-button__text-checkbox--disabled': field.noEditable}"
            [innerHTML]="field.description"></span>
          @if(field.required){
            <span class="common-tag__mandatory-text-asterisk">*</span>
          }
          <div class="common-text-input__block-buttons">
              @if (field.references?.length) {
                <tooltip-law [references]="field.references"
                [field]="field"></tooltip-law>
              }
              @if (field.relatedInfo?.length){
                <button class="common-button__icon-sm-noborder"
                    pTooltip="{{'common.related-info'| afTranslate}}"
                    tooltipPosition="top"
                    (click)="openModalRelatedInfo(field.relatedInfo, $event)">
                    <i class="lf-icon-search-text common-icon__md"></i>
                </button>
              }
              @if (field.inReport !== null && field.inReport !== undefined && !isLanding){
                <tooltip-in-report [inReport]="fieldTypeTxchk.inReport"></tooltip-in-report>
              }
          </div>
        </div>
      </div>
    </div>
    @if(field.error){
      <div class="common-text-input__mandatory-tag">
        @if(field.blocker){
          <i class="lf-icon-warning common-icon__error-md"></i>
        }
        <span [afTranslate]="field.blocker?'common.field-mandatory-blocking':'common.field-mandatory'">Campo obligatorio</span>
      </div>
    }
  </div>
}
